import $ from 'jquery';
import {getCookie, setCookie} from './cookies.js';

class VehiclesComparatorLinks {
    constructor(links) {
        this.$links = $(links);
        this._init();
    }

    _init() {
        if(this.$links.length) {
            this._bindEvents();
        }
    }

    _bindEvents() {
        this.onVehiclesComparatorLinkToggleFn = this._onVehiclesComparatorLinkToggle.bind(this);

        this.$links.on('click', this.onVehiclesComparatorLinkToggleFn);
        
        document.addEventListener('vehiclesComparator:bindLinks', (e) => {
            if(e?.detail?.links) {
                $(e.detail.links).on('click', this.onVehiclesComparatorLinkToggleFn);
            }
        });
    }

    _onVehiclesComparatorLinkToggle(e) {
        e.preventDefault();
        
        let $target = $(e.target);
        
        if(!$target.hasClass('vehicles-comparator-link')) {
            $target = $target.parents('.vehicles-comparator-link');
        }

        if($target.length) {
            const vehicleId = $target[0].hasAttribute('data-id') ? $target.attr('data-id') : null;

            if(vehicleId) {
                if($target.hasClass('vehicles-comparator-link--active')) {
                    this._updateComparator(vehicleId, 'remove', $target);
                }
                else {
                    this._updateComparator(vehicleId, 'add', $target);
                }
            }
        }
    }

    _updateComparator(id, action, $target) {
        let comparatorData = getCookie('cha_comparator');

        if(comparatorData) {
            comparatorData = JSON.parse(comparatorData);
        }
        
        if(!Array.isArray(comparatorData)) {
            comparatorData = [];
        }

        comparatorData = new Set([...comparatorData]);

        if(action === 'add' && comparatorData.size + 1 > 3) {
            return;
        }

        if(action === 'add' && !comparatorData.has(id)) {
            comparatorData.add(id);
            $target.addClass('vehicles-comparator-link--active');
        }
        else if(action === 'remove' && comparatorData.has(id)) {
            comparatorData.forEach((vehicleId) => {
                if(vehicleId === id) {
                    comparatorData.delete(vehicleId);
                }
            });
            $target.removeClass('vehicles-comparator-link--active');
        }

        if(comparatorData.size >= 3) {
            document.body.classList.add('vehicles-comparator-full');
        }
        else {
            document.body.classList.remove('vehicles-comparator-full');
        }

        setCookie('cha_comparator', JSON.stringify([...comparatorData]), 0);
    }
}

export default VehiclesComparatorLinks;

const initVehiclesComparatorLinks = function() {
    const links = document.querySelectorAll('.vehicles-comparator-link[data-id]');
    
    if(links.length) {
        const instance = new VehiclesComparatorLinks(links);
    }
};

if(document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', initVehiclesComparatorLinks);
}
else {
    initVehiclesComparatorLinks();   
}